// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3leVX","questions":"styles_questions__7M_rY","footer":"styles_footer__1J0q7"};